import React from 'react';
import { toast } from 'sonner';
import api from '../../utils/api';
import { Horse, Megaphone } from '@phosphor-icons/react';
import { LastSyncedPill } from '../LastSyncedPill';
import { ThemeToggle } from '../ThemeToggle';

export const DashboardHeader = ({ user, userRoles, isMaster, isRider, isProducer, activeView, onToggleView }) => {
  const isDualRole = isRider && isProducer;

  return (
    <div className="mb-8 sm:mb-10">
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl sm:text-4xl font-black text-white mb-1" style={{fontFamily: 'Outfit'}}>
            Welcome, <span className="text-[#0096FF]">{user.name}</span>
          </h1>
          <p className="text-[#9E9E9E] text-xs sm:text-sm">
            {userRoles.map(r => r.replace('_', ' ')).join(' & ')}
          </p>
          <ThemeToggle />
          <div className="mt-2"><LastSyncedPill /></div>
        </div>

        {isDualRole && !isMaster && (
          <div className="flex items-center bg-[#161616] border border-[#262626] rounded-lg p-1 self-start" data-testid="role-toggle">
            <button
              onClick={() => onToggleView('RIDER')}
              data-testid="toggle-rider-view"
              className={`flex items-center gap-1.5 sm:gap-2 px-3 sm:px-5 py-2 sm:py-2.5 rounded-md text-xs sm:text-sm font-bold transition-all duration-200 ${
                activeView === 'RIDER'
                  ? 'bg-[#0096FF] text-white shadow-lg shadow-[#0096FF]/20'
                  : 'text-[#9E9E9E] hover:text-white'
              }`}
            >
              <Horse size={16} weight={activeView === 'RIDER' ? 'fill' : 'duotone'} />
              Rider
            </button>
            <button
              onClick={() => onToggleView('PRODUCER')}
              data-testid="toggle-producer-view"
              className={`flex items-center gap-1.5 sm:gap-2 px-3 sm:px-5 py-2 sm:py-2.5 rounded-md text-xs sm:text-sm font-bold transition-all duration-200 ${
                activeView === 'PRODUCER'
                  ? 'bg-[#00D4FF] text-white shadow-lg shadow-[#00D4FF]/20'
                  : 'text-[#9E9E9E] hover:text-white'
              }`}
            >
              <Megaphone size={16} weight={activeView === 'PRODUCER' ? 'fill' : 'duotone'} />
              Producer
            </button>
          </div>
        )}
      </div>

      {!isMaster && !isDualRole && (
        <div className="flex gap-2 mt-3">
          {!isRider && (
            <button
              onClick={async () => {
                const newRoles = [...userRoles, 'RIDER'];
                try {
                  await api.patch('/auth/roles', { roles: newRoles });
                  toast.success('Rider role added! Refresh to see changes.');
                  window.location.reload();
                } catch { toast.error('Failed to update roles'); }
              }}
              className="px-3 py-1.5 text-xs font-bold bg-[#0096FF]/10 border border-[#0096FF]/30 text-[#0096FF] rounded-lg hover:bg-[#0096FF]/20 transition-colors"
              data-testid="add-rider-role-btn"
            >
              + Add Rider Role
            </button>
          )}
          {!isProducer && (
            <button
              onClick={async () => {
                const newRoles = [...userRoles, 'ORG_ADMIN'];
                try {
                  await api.patch('/auth/roles', { roles: newRoles });
                  toast.success('Producer role added! Refresh to see changes.');
                  window.location.reload();
                } catch { toast.error('Failed to update roles'); }
              }}
              className="px-3 py-1.5 text-xs font-bold bg-[#00D4FF]/10 border border-[#00D4FF]/30 text-[#00D4FF] rounded-lg hover:bg-[#00D4FF]/20 transition-colors"
              data-testid="add-producer-role-btn"
            >
              + Add Producer Role
            </button>
          )}
        </div>
      )}
    </div>
  );
};
